import {callsApi} from 'sources/api';
import LibraryActions from 'actions/library/LibraryActions';

/**
 * API for accessing library highlights (add files to library with selected highlights)
 */
const LibraryHighlightSource = {
  fetchLibraryHighlights: {
    remote(state, libraryId, fileUploadId) {
      return callsApi.getJson(`/calls/${fileUploadId}/library/${libraryId}/highlights`);
    },
    success: LibraryActions.fetchLibraryHighlightsSuccess,
    error: LibraryActions.fetchLibraryHighlightsError,
  },

  addLibraryHighlight: {
    remote(state, libraryId, fileUploadId, highlightElasticId) {
      return callsApi.postJson(`/calls/${fileUploadId}/library/${libraryId}/highlight`, {
        highlightId: highlightElasticId,
      });
    },
    success: LibraryActions.addLibraryHighlightSuccess,
    error: LibraryActions.addLibraryHighlightError,
  },

  removeLibraryHighlight: {
    remote(state, libraryId, fileUploadId, highlightId) {
      return callsApi.delete(
        `/calls/${fileUploadId}/library/${libraryId}/highlight/${highlightId}`
      );
    },
    success: LibraryActions.removeLibraryHighlightSuccess,
    error: LibraryActions.removeLibraryHighlightError,
  },
};

export default LibraryHighlightSource;
